import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IStoreReceiptSummary } from '../../types/air-splitting/store-board';

const hostUrl = getHostbaseUrl();

/**
 * 分账门店看板 - 账单统计
 */
export async function queryBoardStoreSummary() {
  let data = [] as IStoreReceiptSummary[];

  try {
    const { code, context, message } = await Http.get<IStoreReceiptSummary[]>(`${hostUrl}/pay/board/store-receipt-summary`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    } else {
      data = context || [] as IStoreReceiptSummary[];
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}